import { render, staticRenderFns } from "./form-contracts.vue?vue&type=template&id=6c248cba&"
import script from "./form-contracts.vue?vue&type=script&lang=js&"
export * from "./form-contracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports